/**
*
*   Rewards Provider
*       - Manages the User Points
*
**/
'use client';
import Config from '@/config';
import Preloader from '@/components/preloader';
import ShopifyTools from '@/libraries/shopify-tools/class';
import { CustomerContext } from '@/context/customer';
import { useContext, useState } from 'react';
import { useTranslations } from 'next-intl';

//Create the Cart Context
export default function RewardsHook(){

	//Get the Customer Context
	const { Customer } = useContext(CustomerContext);

	//The Translations
	const t = useTranslations();


	/**
	*
	*	Rewards
	* 		- Functional Class to manage the Rewards
	*
	* 	Params:
	* 		n/a
	*
	*
	**/
	const Rewards = {

		//The Reward Points and values
		points: Config.rewards,

		//Is the current component loading?
		loading: type => loading[ type ],

		//Has the customer received/completed the reward type
		awarded: type => Customer.get( customer => customer.rewards.rewards.indexOf(type) > -1 ),

		/**
		*
		* 	value
		* 		- Has the person received the points
		*
		* 	Params:
		* 		type: (String) The reward type ot check the value of
		*
		*
		**/
		value:  type => ( Rewards.points?.[type]?.value || 0 ),

		/**
		*
		* 	text
		* 		- Output the Reward Points in text
		*
		* 	Params:
		* 		type: (String) The reward type to return
		*
		*
		**/
		text:  type => {

			if( loading[ type ] || Customer.loading ) return (<Preloader status={ true } mini />);

			//Points already obtained
			if( Rewards.awarded(type) ) return (<i className="far fa-check-circle"></i>);

			//Return Total Points
			return t('Pages.Account.Points.get-points', { points: Rewards.value( type ) } );

		},

		/**
		*
		* 	add
		* 		- Add Points to the persons account
		*
		* 	Params:
		* 		type: (String) The reward type ot check the value of
		*
		*
		**/
		add: async ( type ) => {

			//Show Loading
			setLoading({
				...loading,
				[type]: true
			});

			//Add the Points
			const response = await ShopifyTools.Rewards.points.add( type );

			if( response.result ){

				//Get the rewards
				const rewards = response.rewards;

				//Set the Base
				rewards.base = ( rewards.points || 0 );

				//Get the Current Rewards
				const current = Customer.get( customer => customer.rewards );

				//Get the Difference (if any)
				const difference = ( current.base - current.points );

				//Remove the difference to keep the point system inline
				if( difference > 0 ) rewards.points = rewards.points - difference;

				//Update the Rewards
				Customer.set({ rewards: rewards });

			}else{

				//Output the error
				//Skip

			}

			//Remove the Loader
			setLoading({
				...loading,
				[type]: false
			});

		}

	};


	//Add the Points to loading
	const [ loading , setLoading ] = useState( ((list)=>{
		Object.keys( Rewards.points ).forEach( point => list[ point ] = false );
		return list;
	})({}) );



	//Return the Provider
	return Rewards;

}